export default __webpack_public_path__ + "static/2-26033635b174f7b8ea32601550f12f83.png";